import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ล่ามพูดพร้อม (Simultaneous) — ประชุมนานาชาติ + อุปกรณ์บูธ","metaTitle":"ล่ามพูดพร้อม Simultaneous — งานประชุมนานาชาติ ทีมล่าม + บูธ | NYC","metaDesc":"ล่ามพูดพร้อมสำหรับงานประชุมนานาชาติ AIIC-grade /วัน/ล่าม พร้อมบูธ ISO 4043, Bosch Integrus 64 CH และเทคนิเชียนหน้า — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ"},"en":{"h1":"Simultaneous Interpreter — Conference Booth & Bosch Integrus 64ch","metaTitle":"Simultaneous Interpreter Bangkok — AIIC Team + Booth Rental | NYC","metaDesc":"AIIC-grade simultaneous interpreters /day/interpreter with ISO 4043 booth, Bosch Integrus 64-channel recei — Send your documents for a free eligibility check."}} as const;

export const Route = createFileRoute("/interpreter/simultaneous")({
  head: () => {
    const url = `${SEO_SITE}/interpreter/simultaneous`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/interpreter/simultaneous", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/interpreter/simultaneous", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/interpreter/simultaneous", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/interpreter/simultaneous", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/interpreter/simultaneous", "/en/interpreter/simultaneous")],
    };
  },
  component: () => <SubServicePage slug="interpreter/simultaneous" locale="th" />,
});
